// ハイライトの色オプション
export const HIGHLIGHT_COLORS = [
  { value: 'yellow', label: '黄', className: 'bg-yellow-400/60', hex: '#facc15' },
  { value: 'green', label: '緑', className: 'bg-green-400/60', hex: '#4ade80' },
  { value: 'blue', label: '青', className: 'bg-blue-400/60', hex: '#60a5fa' },
  { value: 'pink', label: 'ピンク', className: 'bg-pink-400/60', hex: '#f472b6' },
  { value: 'purple', label: '紫', className: 'bg-purple-400/60', hex: '#a78bfa' },
] as const

export type HighlightColor = (typeof HIGHLIGHT_COLORS)[number]['value']
